export default __webpack_public_path__ + "static/img-5-741adfe3fd86357acf1b8ec49647ad20.png";